import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { appendTrackingPixels } from '../../utils/thirdPartyTracking/helpers';

const eventMappings = {};
eventMappings[actions.LINK_SUCCESS] = [trackSuccessAction];
eventMappings[actions.LINK_COMPLETE] = [trackCompleteAction];

export default function trackLink(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackCompleteAction(state) {
    appendTrackingPixels('clickThrough', state);
}

function trackSuccessAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: getActionCompletedTime(state, 'link')()
    });
}
